export default function EmptyState({ message }: { message: string }) {
  return (
    <div className="rounded border border-border bg-card px-4 py-8 text-center text-sm text-text-secondary">
      {message}
    </div>
  )
}
